import { ProviderMessageType, PROVIDER_SOURCE, CONSUMER_SOURCE } from './consts';
export var OperationType;
(function (OperationType) {
    OperationType["PROVIDER_SEND"] = "\u7F16\u8F91\u5668\u53D1\u9001";
    OperationType["PROVIDER_RECEIVE"] = "\u7F16\u8F91\u5668\u63A5\u6536";
    OperationType["CONSUMER_SEND"] = "\u9884\u89C8\u9875\u9762\u53D1\u9001";
    OperationType["CONSUMER_RECEIVE"] = "\u9884\u89C8\u9875\u9762\u63A5\u6536";
    OperationType["ERROR_DETECTION"] = "\u9519\u8BEF\u68C0\u6D4B";
    OperationType["UPDATE_PAGE_CONFIG"] = "\u66F4\u65B0\u9875\u9762\u914D\u7F6E";
})(OperationType || (OperationType = {}));
export class PreviewDebugger {
    logs = [];
    maxLogs = 100;
    maxPayloadLength = 1000; // 最大payload长度
    consumerLogs = []; // 存储来自consumer的日志
    /**
     * 记录操作日志
     */
    log(type, result, options) {
        const log = {
            type,
            timestamp: Date.now(),
            result,
            ...options,
            payload: options?.payload ? this.truncatePayload(options.payload) : undefined,
        };
        this.logs.push(log);
        // 保持最多100条记录
        if (this.logs.length > this.maxLogs) {
            this.logs.shift();
        }
    }
    /**
     * 打印所有日志（包括consumer的）
     */
    async print() {
        const allLogs = this.getAllLogs();
        console.group('Preview Debugger Logs');
        console.log(`Total logs: ${allLogs.length} (Provider: ${this.logs.length}, Consumer: ${this.consumerLogs.length})`);
        allLogs.forEach((log, index) => {
            const time = new Date(log.timestamp).toLocaleTimeString();
            const statusIcon = {
                success: '✅',
                error: '❌',
                warning: '⚠️',
            };
            const status = statusIcon[log.result] || statusIcon.warning;
            const sourceType = {
                [PROVIDER_SOURCE]: '[Provider]',
                [CONSUMER_SOURCE]: '[Consumer]',
            };
            const source = sourceType[log.source] || '[Unknown]';
            console.group(`${status} [${index + 1}] ${time} ${source} - ${log.type} ${log.messageType}`);
            console.log('Message Type:', log.messageType);
            if (log.errorMessage)
                console.log('Error:', log.errorMessage);
            if (log.duration)
                console.log('Duration:', `${log.duration}ms`);
            if (log.payload)
                console.log('Payload:', log.payload);
            console.groupEnd();
        });
        console.groupEnd();
    }
    /**
     * 获取最近的日志
     */
    getRecentLogs(count = 10) {
        return this.logs.slice(-count);
    }
    /**
     * 清空日志
     */
    clear() {
        this.logs = [];
    }
    /**
     * 添加来自consumer的日志
     */
    addConsumerLogs(logs) {
        this.consumerLogs.push(...logs);
        // 保持consumer日志也最多100条
        if (this.consumerLogs.length > this.maxLogs) {
            this.consumerLogs = this.consumerLogs.slice(-this.maxLogs);
        }
    }
    /**
     * 获取所有日志（包括provider和consumer的）
     */
    getAllLogs() {
        const allLogs = [...this.logs, ...this.consumerLogs];
        return allLogs.sort((a, b) => a.timestamp - b.timestamp);
    }
    /**
     * 请求consumer发送日志
     */
    requestConsumerLogs(postMessage, previewerId) {
        postMessage({}, ProviderMessageType.requestDebuggerLogs, [previewerId]);
    }
    /**
     * 截断过长的payload
     */
    truncatePayload(payload) {
        if (typeof payload === 'string') {
            return payload.length > this.maxPayloadLength
                ? `${payload.substring(0, this.maxPayloadLength)}...`
                : payload;
        }
        if (typeof payload === 'object' && payload !== null) {
            const payloadStr = JSON.stringify(payload);
            if (payloadStr.length > this.maxPayloadLength) {
                return `${payloadStr.substring(0, this.maxPayloadLength)}...`;
            }
        }
        return payload;
    }
}
// 创建全局debugger实例
export const previewDebugger = new PreviewDebugger();
// 导出便捷方法
export const logProviderSend = (messageType, payload, targetPreviewerIds) => {
    previewDebugger.log(OperationType.PROVIDER_SEND, 'success', {
        messageType,
        source: PROVIDER_SOURCE,
        targetPreviewerIds,
        payload,
    });
};
export const logProviderReceive = (messageType, payload) => {
    previewDebugger.log(OperationType.PROVIDER_RECEIVE, 'success', {
        messageType,
        source: PROVIDER_SOURCE,
        payload,
    });
};
export const logConsumerSend = (messageType, payload) => {
    previewDebugger.log(OperationType.CONSUMER_SEND, 'success', {
        messageType,
        source: CONSUMER_SOURCE,
        payload,
    });
};
export const logConsumerReceive = (messageType, payload, targetPreviewerIds) => {
    previewDebugger.log(OperationType.CONSUMER_RECEIVE, 'success', {
        messageType,
        source: CONSUMER_SOURCE,
        targetPreviewerIds,
        payload,
    });
};
export const logError = (type, messageType, errorMessage, payload) => {
    previewDebugger.log(type, 'error', {
        messageType,
        payload,
        errorMessage,
    });
};
export const requestConsumerLogs = (postMessage, previewerId) => {
    previewDebugger.requestConsumerLogs(postMessage, previewerId);
};
